import {
    GET_STEP_REQUEST, GET_STEP_SUCCESS, GET_STEP_FAIL,
    GET_STEPS_BY_CAREER_PATH_REQUEST, GET_STEPS_BY_CAREER_PATH_SUCCESS, GET_STEPS_BY_CAREER_PATH_FAIL,
    ADD_STEP_REQUEST, ADD_STEP_SUCCESS, ADD_STEP_FAIL,
    UPDATE_STEP_REQUEST, UPDATE_STEP_SUCCESS, UPDATE_STEP_FAIL,
    DELETE_STEP_REQUEST, DELETE_STEP_SUCCESS, DELETE_STEP_FAIL,
    SET_STEP_LOADING
} from '../actions/careerPathStepActions';

const initialState = {
    steps: [],
    currentStep: null,
    loading: false,
    error: null
};

function careerPathStepReducer(state = initialState, action) {
    switch (action.type) {

        case SET_STEP_LOADING:
            return { ...state, loading: action.payload };

        case GET_STEP_REQUEST:
        case GET_STEPS_BY_CAREER_PATH_REQUEST:
        case ADD_STEP_REQUEST:
        case UPDATE_STEP_REQUEST:
        case DELETE_STEP_REQUEST:
            return { ...state, loading: true, error: null };

        case GET_STEP_SUCCESS:
            return { ...state, loading: false, currentStep: action.payload };

        case GET_STEPS_BY_CAREER_PATH_SUCCESS:
            return { ...state, loading: false, steps: action.payload };

        case ADD_STEP_SUCCESS:
            return { ...state, loading: false, steps: [...state.steps, action.payload] };

        case UPDATE_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                steps: state.steps.map(s =>
                    s.id === action.payload.id ? action.payload : s
                ),
                currentStep: state.currentStep?.id === action.payload.id
                    ? action.payload : state.currentStep
            };

        case DELETE_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                steps: state.steps.filter(s => s.id !== action.payload.stepId),
                currentStep: state.currentStep?.id === action.payload.stepId
                    ? null : state.currentStep
            };

        case GET_STEP_FAIL:
        case GET_STEPS_BY_CAREER_PATH_FAIL:
        case ADD_STEP_FAIL:
        case UPDATE_STEP_FAIL:
        case DELETE_STEP_FAIL:
            return { ...state, loading: false, error: action.error };

        default:
            return state;
    }
}

export default careerPathStepReducer;